import { TriggerRule } from 'modules/workflowNodeEditors/components/HoldUntilReply/TriggerRuleUtils';
import {
  TriggerHoldUntilReplyRuleType,
  TriggerHoldUntilReplyRuleValue,
} from 'modules/workflows/constants/nodes/holdUntilReply';
import { HoldUntilReplyNodeData, SingleValueSearchField } from 'modules/workflows/types';
import { TextSegmentConfig } from 'ui/workflows/flowchart/types';

/** Parse trigger rule to extract relevant canvas display information */
const parseTriggerRule = (rule: TriggerRule) => {
  const campaignIdQuery = rule.searchQuery?.searchQueries?.find(
    (query) => 'comparatorType' in query && 'value' in query && query.field === 'campaignId',
  );
  const campaignId = !!campaignIdQuery
    ? (campaignIdQuery as SingleValueSearchField).value
    : undefined;

  return {
    type: rule.triggerRuleType,
    campaignId,
  };
};

const getTriggerRuleSegments = (triggerRule: TriggerRule) => {
  const parsedRule = parseTriggerRule(triggerRule);
  const { type, campaignId } = parsedRule;

  const isWhatsApp = type === TriggerHoldUntilReplyRuleType.WHATSAPP;

  const triggerTypeDisplay = isWhatsApp
    ? TriggerHoldUntilReplyRuleValue.WHATSAPP
    : TriggerHoldUntilReplyRuleValue.SMS;

  const segments: Array<{ text: string }[]> = [[{ text: triggerTypeDisplay }]];

  if (isWhatsApp && !!campaignId) {
    const campaignText = `Campaign ID: ${campaignId}`;
    segments.push([{ text: campaignText }]);
  }

  return segments;
};

export const getTextSegments = (
  nodeData: HoldUntilReplyNodeData,
): { nodeDescBottom: TextSegmentConfig } => {
  const { triggerRule } = nodeData;

  // If no trigger rule is configured, show set up message
  if (!triggerRule || !triggerRule.triggerRuleType) {
    return {
      nodeDescBottom: {
        isTruncated: true,
        segments: [{ text: 'Set up...' }],
      },
    };
  }

  // Parse and display trigger rule information
  const triggerRuleSegments = getTriggerRuleSegments(triggerRule);

  return {
    nodeDescBottom: {
      isTruncated: true,
      segments: triggerRuleSegments,
    },
  };
};
